import { render, staticRenderFns } from "./KBZForm.vue?vue&type=template&id=0e7bcec4"
import script from "./KBZForm.vue?vue&type=script&lang=js"
export * from "./KBZForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports